import { Dic } from '$utils'
export const partOption = function (that) {
  let deviceMarkList = []
  Dic.find('SENU087').map(item => {
    if (item.value == '27' || item.value == '28' || item.value == '29') {
      deviceMarkList.push(item)
    }
  })
  return {
    add: '新增部件',
    edit: '修改部件',
    view: 'bu详情',
    emptyText: that.$t("deviceAccess.message.nodata"),
    stripe: true,
    maxHeight: "100%",
    page: true,
    align: "center",
    menuAlign: "center",
    labelSuffix: '：',
    header: false,
    selection: true,
    delBtn: false,
    editBtn: false,
    labelWidth: '125px',
    dialogWidth: '700px',
    column: [
      // {
      //   label: '厂商',
      //   prop: "factoryName",
      //   overHidden: true,
      //   editDisplay: true,
      //   viewDisplay: true,
      //   addDisplay: true,
      //   type: 'select',
      //   dicData: [],
      //   rules: [{ required: true, message: '请选择厂商', trigger: 'blur' }],        
      // },
      {
        label: '主机系统类型',
        prop: "deviceMark",
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        type: 'select',
        dicData: deviceMarkList, //SENU087
        viewFormatter: (row, value) => {
          return Dic.findByValue('SENU087', Number(value))
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU087', value) : ''
        },
        rules: [{ required: true, message: '请输入主机系统类型', trigger: 'blur' }]
      },
      // {
      //   label: '主机系统地址',
      //   prop: "parentMac",
      //   overHidden: true,
      //   editDisplay: false,
      //   viewDisplay: true,
      //   addDisplay: false
      // },
      // {
      //   label: '主机类型标识',
      //   prop: "typeMark",
      //   overHidden: true,
      //   editDisplay: false,
      //   viewDisplay: true,
      //   addDisplay: false
      // },
      // {
      //   label: '主机回路',
      //   prop: "parentLoop",
      //   overHidden: true,
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: true,
      //   rules: [

      //     {
      //       min: 4,
      //       max: 30,
      //       message: '长度在 4 到 30 个字符',
      //       trigger: 'blur'
      //     }
      //   ],
      // },
      {
        label: '主机唯一标识号',
        prop: "parentThirdDeviceId",
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        span:24,
        viewDisplay: true,
      },
      {
        label: '部件名称',
        prop: "thirdDeviceName",
        overHidden: true,
        search: true,
        viewDisplay: true,
        editDisplay: true,
        addDisplay: true,
        rules: [{ required: true, message: '请输入部件名称', trigger: 'blur' }]
      },
      // {
      //   label: '部件ID',
      //   prop: "deviceID",
      //   overHidden: true,
      //   hide: true,
      //   viewDisplay: false,
      //   editDisplay: false,
      //   addDisplay: false,
      //   rules: [{ required: true, message: '请选择厂商', trigger: 'blur' }]
      // },
      {
        label: '部件类型',
        prop: "subDeviceMark",
        overHidden: true,
        viewDisplay: true,
        editDisplay: true,
        addDisplay: true,
        type: 'select',
        dicData: Dic.find('SENU094'),//SENU094
        viewFormatter: (row, value) => {
          return Dic.findByValue('SENU094', Number(value))
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU094', Number(value)) : ''
        },
        rules: [{ required: true, message: '请选择部件型号', trigger: 'blur' }]
      },
      {
        label: '部件地址',
        prop: "mac",
        overHidden: true,
        search: true,
        viewDisplay: true,
        editDisplay: true,
        addDisplay: true,
        rules: [{ required: true, message: '请输入部件地址', trigger: 'blur' }]
      },
      // {
      //   label: '回路',
      //   prop: 'loop',
      //   overHidden: true,
      //   editDisplay: true,
      //   addDisplay: true,
      //   rules: [{ required: true, message: '请输入回路', trigger: 'blur' }]
      // },
      // {
      //   label: '二次码',
      //   prop: 'secondaryCode',
      //   overHidden: true,
      //   editDisplay: true,
      //   addDisplay: true,
      //   rules: [{ required: false, message: '请输入二次码', trigger: 'blur' }]
      // },
      // {
      //   label: '控制器编号',
      //   prop: 'controlCode',
      //   overHidden: true,
      //   editDisplay: true,
      //   addDisplay: true,
      //   // rules: [{ required: false, message: '请输入控制器编号', trigger: 'blur' }]
      // },
      // {
      //   label: "状态",
      //   prop: "status",
      //   overHidden: true,
      //   addDisplay: true,
      //   viewDisplay: true,
      //   type: 'select',
      //   dicData: [
      //     {
      //       label: '在线',
      //       value: '1'
      //     },
      //     {
      //       label: '离线',
      //       value: '0'
      //     }
      //   ],
      //   formatter: function (row, value) {
      //     return Number(value) === 1 ? '在线' : '离线'
      //   },
      //   viewFormatter: (row, value) => {
      //     return Number(value) === 1 ? '在线' : '离线'
      //   },
      // },
      {
        label: '部件说明',
        prop: "thirdDeviceDesc",
        overHidden: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 24,
        type: 'textarea',
        minRows: 3,
        maxlength: 200,
        rules: [{ required: true, message: '请输入部件说明', trigger: 'blur' }]
      },
      {
        label: '更新时间',
        prop: "createTime",
        overHidden: true,
        editDisplay: false,
        addDisplay: false,
        viewDisplay: true
      },
    ],
  }
}
